import cc from 'classcat'

export const treeLines = {
  space: 'ep-page-tree-insertion',
  lineDown: 'level-down',
  lineDownRight: 'level-down-right',
  lineRight: 'level-right',
}

export const maxNestedPageLevel = 4

const branchingVisualisation = (symbol, index) => <div key={index} className={symbol} />

type PageTreePartProps = {
  page: ImmutableMap
}

function PageTreePart({ page }: Readonly<PageTreePartProps>) {
  if (!page.get('level')) return null

  return (
    <div className="ep-page-tree">
      {page.get('branchDrawPattern') && page.get('branchDrawPattern').map(branchingVisualisation)}
    </div>
  )
}

type PageTitleProps = {
  page: ImmutableMap
}

function PageTitle({ page }: Readonly<PageTitleProps>) {
  return <div className={cc([{ 'ep-page-main': !page.get('slug') }])}>{`${page.get('title')}`}</div>
}

type PageOptionProps = {
  page: ImmutableMap
  isSelected?: boolean
}

export function PageOption({ page }: Readonly<PageOptionProps>) {
  return (
    <>
      <span className={`ep-page-insertion`} />
      <PageTreePart page={page} />
      <PageTitle page={page} />
    </>
  )
}
